import Textarea from './Textarea';

export * from './Textarea';

export default Textarea;
